import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Popconfirm } from 'antd';
import { message } from '../utils/antdMessage';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import apiFetch from '../utils/apiFetch'; // 假设有统一的API请求工具
import './Devices.css'; // 可选：自定义样式

/**
 * 设备管理页面
 * 功能：展示设备列表，支持添加、编辑、删除设备
 */
const Devices = () => {
  // 设备列表状态
  const [devices, setDevices] = useState([]);
  // 控制弹窗显示
  const [modalVisible, setModalVisible] = useState(false);
  // 当前编辑的设备
  const [current, setCurrent] = useState(null);
  // 加载状态
  const [loading, setLoading] = useState(false);
  // 表单实例
  const [form] = Form.useForm();

  // 获取设备列表
  const fetchDevices = async () => {
    setLoading(true);
    try {
      const res = await apiFetch('/api/device/list');
      const data = await res.json();
      if (data.success) {
        setDevices(data.devices);
      } else {
        message.error('获取设备列表失败');
      }
    } catch (e) {
      message.error('网络错误');
    }
    setLoading(false);
  };

  // 页面加载时获取设备
  useEffect(() => {
    fetchDevices();
  }, []);

  // 打开新增/编辑弹窗
  const openModal = (record = null) => {
    setCurrent(record);
    setModalVisible(true);
    if (record) {
      form.setFieldsValue(record);
    } else {
      form.resetFields();
    }
  };

  // 提交表单（新增或编辑）
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      let url = current ? `/api/device/update/${current.id}` : '/api/device/create';
      let method = current ? 'POST' : 'POST';
      const res = await apiFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
      });
      const data = await res.json();
      if (data.success) {
        message.success(current ? '编辑成功' : '添加成功');
        setModalVisible(false);
        fetchDevices();
      } else {
        message.error(data.message || '操作失败');
      }
    } catch (e) {
      // 校验失败不处理
    }
  };

  // 删除设备
  const handleDelete = async (id) => {
    try {
      const res = await apiFetch(`/api/device/delete/${id}`, { method: 'POST' });
      const data = await res.json();
      if (data.success) {
        message.success('删除成功');
        fetchDevices();
      } else {
        message.error(data.message || '删除失败');
      }
    } catch (e) {
      message.error('网络错误');
    }
  };

  // 表格列定义
  const columns = [
    { title: '设备名称', dataIndex: 'name', key: 'name' },
    { title: '设备型号', dataIndex: 'device_model', key: 'device_model' },
    { title: '最后上线', dataIndex: 'last_seen', key: 'last_seen' },
    { title: '电量', dataIndex: 'battery_level', key: 'battery_level' },
    { title: '操作', key: 'action', render: (_, record) => (
      <>
        <Button icon={<EditOutlined />} size="small" onClick={() => openModal(record)} style={{ marginRight: 8 }}>编辑</Button>
        <Popconfirm title="确定要删除该设备吗？" onConfirm={() => handleDelete(record.id)} okText="确定" cancelText="取消">
          <Button icon={<DeleteOutlined />} size="small" danger>删除</Button>
        </Popconfirm>
      </>
    ) }
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2>设备管理</h2>
        <div>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()}>添加设备</Button>
          <Button icon={<ReloadOutlined />} onClick={fetchDevices} style={{ marginLeft: 8 }}>刷新</Button>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={devices}
        rowKey="id"
        loading={loading}
        bordered
        pagination={{ pageSize: 10 }}
        scroll={{ x: true }}
      />
      <Modal
        title={current ? '编辑设备' : '添加设备'}
        open={modalVisible}
        onOk={handleOk}
        onCancel={() => setModalVisible(false)}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="设备名称" rules={[{ required: true, message: '请输入设备名称' }]}> <Input /> </Form.Item>
          <Form.Item name="device_model" label="设备型号" rules={[{ required: true, message: '请输入设备型号' }]}> <Input /> </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Devices; 